import React, { useContext } from 'react'
import HelpButton from './HelpButton'

import instructionsPDF from '../../content/files/instructions.pdf'
import Common from '../../context/Common'

function ProbeHelp() {
    const common = useContext(Common)
    let auth = common?.auth

    if (auth != "customer") {
        return <React.Fragment></React.Fragment>
    }

    return (
        <React.Fragment>
            <HelpButton modelId = 'probe-help' />

            <div class = "modal fade" id = "probe-help" role = "dialog">
                <div class = "modal-dialog modal-lg">
                    <div class = "modal-content">
                        <div class = "modal-header">
                            <h3 class = "modal-title">Exercise Help</h3>
                            <button type = "button" class = "close" data-dismiss = "modal">&times;</button>
                        </div>
                        <div class = "modal-body row text-left" style={{marginLeft: '10px', marginRight: '10px', fontSize: '17px'}}>
                            <h3 style={{marginTop: '3px'}}>Instruction Tips for Exercises</h3>
                            <ul>
                                <li style={{paddingBottom: '10px'}}>Before beginning, make sure that the student is comfortable and focused.</li>
                                <li style={{paddingBottom: '10px'}}><strong>IMMEDIATE CORRECTION: Immediately correct errors</strong> and click or tap the word once to mark it as an error, highlighting it in red.</li>

                                <li style={{paddingBottom: '10px'}}>If the student <strong>finishes before time is up</strong>, stop the timer and double click/tap the last word of the exercise to provide the word count.</li>

                                <li style={{paddingBottom: '10px'}}><strong>MODELING:</strong> After the timing, choose a section, one or two lines that contained errors, to model with the student. First you read it properly, then read it together with the student and finally have them read it on their own. </li>

                                <li style={{paddingBottom: '10px'}}><strong>POSITIVE REINFORCEMENT:</strong> Frequent encouragement as students work through timings is essential for keeping focus and motivation.</li>
                                <li><strong>You must immediately correct errors, and model segments for fidelity.</strong></li>
                            </ul>
                            <h3 style={{width: '100%'}}>Watch</h3>
                            <p>
                                <a href = "https://www.youtube.com/watch?v=h51TfIYyZ1A" target="_blank">Immediate Correction Example</a>
                            </p>
                            <p>
                                <a href = "https://www.youtube.com/watch?v=zU0xDgUO5aI" target="_blank">Modeling Example</a>
                            </p>
                            <p style={{marginBottom: '25px'}}>
                                <a href = "https://www.youtube.com/watch?v=2MdUOxKM6sY&t=2s" target="_blank">Positive Reinforcement Example</a>
                            </p>

                            <p class = "text-center">For more in depth instructions, <a href={instructionsPDF} target="_blank">click here</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ProbeHelp
